module.exports = __webpack_public_path__ + "img/payWithPoints.2a8d63ac.svg";